import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardLiveQueryOptions } from '../api/liveQuery';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import {
  DEFAULT_QUEUE_PAGE,
  EMPTY_QUEUE_FILTERS,
  MissingTimesheetData,
  QueueFilterValues,
  QueuePage,
} from '../api/types';

// Hired workers on ended shifts with no timesheet data, grouped by shift.
const useMissingTimesheetQueue = (
  agencyId: number,
  filters: QueueFilterValues = EMPTY_QUEUE_FILTERS,
  page: QueuePage = DEFAULT_QUEUE_PAGE,
) =>
  useQuery<MissingTimesheetData>({
    queryKey: dashboardV2QueryKeys.missingTimesheet(agencyId, filters, page),
    queryFn: () =>
      dashboardV2Client.getMissingTimesheet(agencyId, filters, page),
    enabled: agencyId != null,
    ...dashboardLiveQueryOptions,
  });

export default useMissingTimesheetQueue;
